import { toAbsoluteUrl } from "@/navigation/absoluteUrl";
import type { AppLocationCodec } from "@/navigation/appLocation";
import { NAV_KEYS } from "@/navigation/keys";

export type ClientsListLocation = {
  focus?: string;
};

function readString(params: Record<string, string | undefined>, key: string): string | undefined {
  return params[key]?.trim() || undefined;
}

function normalize(loc: ClientsListLocation): ClientsListLocation {
  const next: ClientsListLocation = {};
  if (loc.focus) next.focus = loc.focus;
  return next;
}

function fromParams(params: Record<string, string | undefined>): ClientsListLocation {
  const loc: ClientsListLocation = {};
  const focus = readString(params, NAV_KEYS.focus);
  if (focus) loc.focus = focus;
  return normalize(loc);
}

function fromUrl(pathname: string, searchParams: URLSearchParams): ClientsListLocation {
  return fromParams(Object.fromEntries(searchParams));
}

function toParams(loc: ClientsListLocation): Record<string, string> {
  const n = normalize(loc);
  const out: Record<string, string> = {};
  if (n.focus) out[NAV_KEYS.focus] = n.focus;
  return out;
}

function toUrl(loc: ClientsListLocation): string {
  const qs = new URLSearchParams(toParams(loc)).toString();
  return `/clients${qs ? `?${qs}` : ""}`;
}

export const clientsListCodec: AppLocationCodec<ClientsListLocation> = {
  appId: "clients",
  fromUrl,
  fromParams,
  toParams,
  toUrl,
};

export function clientsListShareUrl(loc: ClientsListLocation): string {
  return toAbsoluteUrl(clientsListCodec.toUrl(loc));
}
